<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <!-- Título y subtítulo -->
      <v-row justify="start" align="start" class="ma-0 mb-4 mt-5">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: black;">
            Líneas de crédito activas
          </div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            Aquí puedes revisar todas las líneas aprobadas y disponibles para operar crédito revolvente.
          </div>
        </v-col>
      </v-row>

      <!-- Buscador -->
      <v-row class="ma-0 mb-4" style="align-items: center;">
        <v-col cols="12" sm="4" md="3" class="pl-0">
          <v-text-field
            v-model="search"
            label="Buscar cliente"
            hide-details
            append-icon="mdi-magnify"
            outlined
            style="font-family: 'montserrat-medium'; border-radius: 20px; background-color: white;"
          />
        </v-col>
        <v-spacer />
        <v-btn rounded color="black" class="white--text" @click="dialogCreateCreditLine = true, getAvailableEnterprises(), creditLine = {}" style="font-family: 'montserrat-bold';">
          Asignar linea
        </v-btn>
      </v-row>

      <!-- Tabla de contratos -->
      <v-data-table
        :items="creditLines"
        hide-default-header>
        <template v-slot:header>
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">Empresa</th>
              <th class="header__title center">Límite aprobado</th>
              <th class="header__title center">Disponible</th>
              <th class="header__title center">Moneda</th>
              <th class="header__title center">Tasa (%)</th>
              <th class="header__title center">Estatus</th>
              <th class="header__title right">Acciones</th>
            </tr>
          </thead>
        </template>

        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.enterprise_name || item.sEnterpriseId }}</td>
              <td class="table__item center">$ {{ formatMoney(item.approved_limit) + " " + (item.currency ? item.currency : "") }}</td>
              <td class="table__item center">$ {{ formatMoney(item.available_amount) + " " + (item.currency ? item.currency : "") }}</td>
              <td class="table__item center">{{ item.currency }}</td>
              <td class="table__item center">{{ item.interest_rate }}%</td>
              <td class="table__item center">
                <v-chip :color="item.status === 'active' ? 'green' : 'red'" small dark>
                  {{ item.status }}
                </v-chip>
              </td>
              <td class="table__item center">
                <v-tooltip v-if="item.has_contract" top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon color="black" @click="viewContract(item)">
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver contrato</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon color="black" @click="">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ "Detalle de disposición" }}</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-dialog v-model="dialogCreateCreditLine" max-width="650px">
        <v-card style="border-radius: 20px; padding: 24px;">
          <v-form ref="formNew" lazy-validation v-on:submit.prevent>
            <!-- Título -->
            <div style="font-family: 'montserrat-bold'; font-size: 22px; text-align: center;">
              Agregar Factura
            </div>
            <v-divider class="my-4" />
            <!-- Información básica -->
            <v-row dense>
              <v-col cols="6">
                <v-select
                  v-model="creditLine.sEnterpriseId"
                  :items="availableEnterprises"
                  item-text="sName"
                  item-value="sEnterpriseId"
                  label="Cliente"
                  style="border-radius: 10px;"
                  outlined
                  class="mb-2"
                  :rules="[rules.required]"
                  hide-details
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="creditLine.approved_limit"
                  label="Monto"
                  outlined
                  style="border-radius: 10px;"
                  class="mb-2"
                  hide-details
                  :rules="[rules.required]"
                  required
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-card
                  flat
                  class="d-flex align-center justify-center flex-column py-2"
                  style="background-color: #f6f6f6; border-radius: 12px; height: 100%; "
                >
                  <div class="mb-1" style="font-family: 'montserrat-bold'; font-size: 14px; color: #333;">
                    Monto total de la linea de crédito
                  </div>
                  <div style="font-family: 'montserrat-bold'; font-size: 20px; color: #333;">
                    {{ creditLine.approved_limit ? ("$" + formatMoney(creditLine.approved_limit) + " " + (creditLine.currency ? creditLine.currency : "")) : "$0.00" }}
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6">
                <v-select
                  v-model="creditLine.currency"
                  :items="['USD', 'MXN']"
                  label="Moneda"
                  style="border-radius: 10px;"
                  outlined
                  class="mb-2"
                  :rules="[rules.required]"
                  hide-details
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="creditLine.interest_rate"
                  label="Tasa de interés (%)"
                  outlined
                  style="border-radius: 10px;"
                  class="mb-2"
                  hide-details
                  :rules="[rules.required]"
                  required
                />
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12">
                <v-file-input
                  v-model="contractFile"
                  label="Contrato (PDF)"
                  accept=".pdf"
                  outlined
                  style="border-radius: 10px;"
                  class="mb-2"
                  hide-details
                  prepend-icon="mdi-paperclip"
                />
              </v-col>
            </v-row>
            <v-divider class="my-4" />

            <!-- Acciones -->
            <v-card-actions>
              <v-btn 
                block
                large
                color="black"
                class="white--text mt-2"
                style="border-radius: 10px; text-transform: none; font-weight: 600;" 
                @click="createCreditLine()"
              >
                Guardar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      search: "",
      creditLinesRaw: [],
      availableEnterprises: [],
      dialogCreateCreditLine: false,
      contractFile: null,
      creditLine: {
        sEnterpriseId: "",
        approved_limit: null,
        interest_rate: null,
        currency: "",
      },
      rules: {
        required: value => !!value || 'Este campo es requerido.',
      },
    };
  },
  methods: {
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    async getCreditLines() {
      try {
        const response = await DB.get(`${URI}/api/v1/en/admin/credit/credit_lines`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.creditLinesRaw = response.data.creditLines;
      } catch (error) {
        this.mixError(error.response.data.message, error.response.status);
      }
    },
    async getAvailableEnterprises() {
      this.availableEnterprises = [];

      try {
        const response = await DB.get(`${URI}/api/v1/en/admin/credit/credit_lines/availableEnterprises`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.availableEnterprises = response.data.results;
      } catch (error) {
        this.mixError(error.response.data.message, error.response.status);
      }
    },
    async viewContract(item) {
      try {
        const res = await DB.get(`${URI}/api/v1/en/admin/credit/credit_lines/${item.id}/contract`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ''
          }
        });
        window.open(res.data.url, '_blank');
      } catch (err) {
        this.$toast.error('Error al obtener el contrato');
      }
    },
    async createCreditLine() {
      const isValid = await this.$refs.formNew.validate();

      if (!isValid) {
        this.mixError('Revisa los campos obligatorios antes de continuar');
        return;
      }

      try {
        const formData = new FormData();
        formData.append('sEnterpriseId', this.creditLine.sEnterpriseId);
        formData.append('approved_limit', this.creditLine.approved_limit);
        formData.append('currency', this.creditLine.currency);
        formData.append('interest_rate', this.creditLine.interest_rate);
        if (this.contractFile) {
          formData.append('contract_file', this.contractFile);
        }

        const response = await DB.post(`${URI}/api/v1/en/admin/credit/credit_lines`, formData, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : '',
            'Content-Type': 'multipart/form-data',
          }
        });
        this.contractFile = null;
        this.getCreditLines();
        this.dialogCreateCreditLine = false;
      } catch (err) {
        this.$toast.error('Error al crear línea de crédito.');
      }
    },
  },
  computed: {
    creditLines() {
      if (!this.search) return this.creditLinesRaw;
      const filtro = this.search.toLowerCase();
      return this.creditLinesRaw.filter(item => {
        return (
          (item.enterprise_name || '').toLowerCase().includes(filtro) ||
          (item.currency || '').toLowerCase().includes(filtro) ||
          (item.status || '').toLowerCase().includes(filtro) ||
          String(item.approved_limit).includes(filtro) ||
          String(item.available_amount).includes(filtro) ||
          String(item.interest_rate).includes(filtro)
        );
      });
    },
  },
  beforeMount() {
    this.getCreditLines();
  },
};
</script>

<style scoped>
.header__title {
  font-family: 'montserrat-semibold';
  font-size: 13px;
  padding: 12px;
}
.header__title.left {
  text-align: left;
}
.header__title.center {
  text-align: center;
}
</style>
